// extracted by mini-css-extract-plugin
export default {"page":"VQ-z","cartModal":"WQ-z","checkout":"XQ-z","placeholder":"YQ-z","account":"ZQ-z"};